import React from 'react'
import { DatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import { FormLabel, Box, FormHelperText } from '@mui/material'

interface InputDateFieldProps extends Partial<Omit<DatePickerProps, 'onChange' | 'value' | 'placeholder'>> {
  value?: string
  onChange?: (value: any) => void
  format?: string
  placeholder?: string
  isDisableFuture?: boolean
  label?: string | string[]
  required?: boolean
  placeholderFontSize?: string | number
  checkdisabled?: boolean
  error?: boolean
  helperText?: string
}

const InputDateField: React.FC<InputDateFieldProps> = ({
  value,
  label,
  onChange,
  format = 'YYYY-MM-DD',
  placeholder = 'Select your date',
  required = false,
  placeholderFontSize,
  checkdisabled = false,
  error = false,
  helperText,

  ...props
}) => {
  return (
    <Box
      className={`xinput-date-custom ${checkdisabled ? 'ant-picker-disabled' : ''}`}
      sx={{
        width: '100%',
        '& .ant-picker-input input::placeholder': {
          fontSize: placeholderFontSize || '0.9375rem',
          lineHeight: '36px'
        }
      }}
    >
      {label && (
        <FormLabel
          required={required}
          sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}
          className={checkdisabled ? 'text-[#2f2b3d66]' : 'text-[#2f2b3de6]'}
        >
          {label}
        </FormLabel>
      )}
      <DatePicker
        label={typeof label === 'string' ? label : label?.[0]}
        value={typeof value === 'string' && value ? dayjs(value, format) : null}
        onChange={(date: dayjs.Dayjs | null) => onChange?.(date ? date.format(format) : '')}
        placeholder={typeof placeholder === 'string' ? placeholder : placeholder[0]}
        format={format}
        style={{ width: '100%', borderRadius: '20px', ...props.style }}
        className='h-[38px]'
        status={error ? 'error' : undefined}
        {...props}
      />
      {helperText && (
        <FormHelperText error={error} sx={{ marginLeft: '14px', marginTop: '4px' }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  )
}

export default InputDateField
